import { Formik } from 'formik';
import { useCallback } from 'react';
import { useConsentStore } from '~/components/Analytics/analytics.hooks';
import { isVault } from '~/components/Dosi/Vault';
import { useMember } from '~/components/Member/Member.hooks';
import { CookieConsentForm } from '~/components/Policy/Cookie/Form';
import styles from './CookieConsent.module.scss';

export const defaultInitialValues = {
  req: true,
  ana: false,
  mkt: false,
};

export const CookieConsent = () => {
  const { req, accept } = useConsentStore();
  const {
    data: { region },
  } = useMember();

  const onSubmit = useCallback(
    async (values) => {
      accept(values);
    },
    [accept]
  );

  if (req || region === 'JP' || isVault) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Formik initialValues={defaultInitialValues} onSubmit={onSubmit}>
        <CookieConsentForm />
      </Formik>
    </div>
  );
};
